"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stripeFeesByCountry = exports.isStripeCountry = exports.stripeCountries = void 0;
exports.stripeCountries = [
    'CH',
    'DK',
    'FI',
    'GB',
    'HK',
    'IE',
    'IN',
    'JP',
    'LU',
    'MX',
    'NZ',
    'RO',
    'SG',
    'US',
];
const isStripeCountry = (countryCode) => exports.stripeCountries.includes(countryCode);
exports.isStripeCountry = isStripeCountry;
// Add more Stripe countries to this list according to
// https://stripe.com/{countryCode}/pricing#pricing-details
const stripeFeesByCountry = (isSandbox) => ({
    US: {
        fixedFeeDomestic: 30, // denominated in cents
        relativeFeeDomestic: isSandbox ? 2.9 : 2.2,
        fixedFeeInternational: 30,
        relativeFeeInternational: 2.9,
    },
    GB: {
        fixedFeeDomestic: 20, // denominated in pence
        relativeFeeDomestic: isSandbox ? 1.4 : 1.2,
        fixedFeeInternational: 20,
        relativeFeeInternational: 2.9,
    },
    DK: {
        fixedFeeDomestic: 180, // denominated in øre i.e 1.80DKK
        relativeFeeDomestic: isSandbox ? 1.4 : 1.2,
        fixedFeeInternational: 180,
        relativeFeeInternational: 2.9,
    },
    IE: {
        fixedFeeDomestic: 25, // denominated in cents
        relativeFeeDomestic: isSandbox ? 1.4 : 1.2,
        fixedFeeInternational: 25,
        relativeFeeInternational: 2.9,
    },
    LU: {
        fixedFeeDomestic: 25, // denominated in cents
        relativeFeeDomestic: isSandbox ? 1.4 : 1.2,
        fixedFeeInternational: 25,
        relativeFeeInternational: 2.9,
    },
    FI: {
        fixedFeeDomestic: 25, // denominated in cents
        relativeFeeDomestic: 1.4,
        fixedFeeInternational: 25,
        relativeFeeInternational: 2.9,
    },
    IN: {
        fixedFeeDomestic: 0,
        // @TODO: Actually it's more complicated than that https://stripe.com/en-in/pricing#pricing-details
        relativeFeeDomestic: 2,
        fixedFeeInternational: 0,
        relativeFeeInternational: 4.3,
    },
    JP: {
        fixedFeeDomestic: 0,
        relativeFeeDomestic: 3.6,
        fixedFeeInternational: 0,
        relativeFeeInternational: 3.6,
    },
    MX: {
        fixedFeeDomestic: 300, // denominated in centavos i.e $3MXN
        relativeFeeDomestic: isSandbox ? 3.6 : 2.2,
        fixedFeeInternational: 0,
        relativeFeeInternational: 4.1,
    },
    SG: {
        fixedFeeDomestic: 50,
        relativeFeeDomestic: 3.4,
        fixedFeeInternational: 50,
        relativeFeeInternational: 3.9,
    },
    RO: {
        fixedFeeDomestic: 100, // @NOTE-RT: Denominated in bani -> 1LEU
        relativeFeeDomestic: 1.4,
        fixedFeeInternational: 100,
        relativeFeeInternational: 2.9,
    },
    NZ: {
        fixedFeeDomestic: 30, // @NOTE-RT: Denominated in cents NZD -> 1NZD
        relativeFeeDomestic: 2.9,
        fixedFeeInternational: 30,
        relativeFeeInternational: 3.9,
    },
    HK: {
        fixedFeeDomestic: 235, // @NOTE-RT: Denominated in cents HKD -> 1HKD
        relativeFeeDomestic: 3.4,
        fixedFeeInternational: 235,
        relativeFeeInternational: 3.9,
    },
    CH: {
        fixedFeeDomestic: 30, // @NOTE-RT: Denominated in rappen CHF -> 1CHF
        relativeFeeDomestic: 2.9,
        fixedFeeInternational: 30,
        relativeFeeInternational: 2.9,
    },
});
exports.stripeFeesByCountry = stripeFeesByCountry;
//# sourceMappingURL=stripeFeesByCountry.js.map